import { API } from '@/constants'

function UploadAdapter(loader, uploadUrl) {
    this.loader = loader;
    this.uploadUrl = API.BASE_URL + uploadUrl || API.BASE_URL + '/v1/menu-services/image-uploads'; // Default URL if not provided
}

// Starts the upload process.
UploadAdapter.prototype.upload = function () {
    const loader = this.loader;
    return loader.file
        .then(function (file) {
            return new Promise(function (resolve, reject) {
                this._initRequest();
                this._initListeners(resolve, reject, file);
                this._sendRequest(file);
            }.bind(this)); // Bind this to ensure the correct context
        }.bind(this)); // Bind this to ensure the correct context
};

// Aborts the upload process.
UploadAdapter.prototype.abort = function () {
    if (this.xhr) {
        this.xhr.abort();
    }
};

// Initializes the XMLHttpRequest object using the URL passed to the constructor.
UploadAdapter.prototype._initRequest = function () {
    const xhr = this.xhr = new XMLHttpRequest();
    xhr.open('POST', this.uploadUrl, true); // Use dynamic URL
    xhr.responseType = 'json';
};

// Initializes XMLHttpRequest listeners.
UploadAdapter.prototype._initListeners = function (resolve, reject, file) {
    const xhr = this.xhr;
    const loader = this.loader;
    const genericErrorText = `Couldn't upload file: ${file.name}.`;

    xhr.addEventListener('error', function () { 
        console.error('Upload error:', genericErrorText); // Log error
        reject(genericErrorText); 
    });
    xhr.addEventListener('abort', function () { 
        console.warn('Upload aborted.'); // Log abort
        reject(); 
    });
    xhr.addEventListener('load', function () {
        const response = xhr.response;

        if (!response || response.error) {
            console.error('Upload response error:', response); // Log response error
            return reject(response && response.error ? response.error.message : genericErrorText);
        }

        resolve({
            default: API.S3_IMAGE_URL + '/' + response['data']
        });
    });

    if (xhr.upload) {
        xhr.upload.addEventListener('progress', function (evt) {
            if (evt.lengthComputable) {
                loader.uploadTotal = evt.total;
                loader.uploaded = evt.loaded;
            }
        });
    }
};

// Prepares the data and sends the request.
UploadAdapter.prototype._sendRequest = function (file) {
    const data = new FormData();
    data.append('upload', file);
    this.xhr.send(data); // Send the request.
};

export default UploadAdapter;